import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import Message from '../auth/Message';
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class MessageModal extends Component {
  render() {
    return (
      <Modal size="tiny" open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      >
       
       <Modal.Content className='border'>
          <Modal.Description>
            <Message />
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(MessageModal);
